import { c as _c } from "react/compiler-runtime";
import type { UserTimelineEventWorkflowStarted } from '@onefootprint/request-types/dashboard';
import type { CustomTypeOptions } from 'i18next';
import { Trans, useTranslation } from 'react-i18next';
import { OnboardingTraceLink } from '@/components';
import Actor from '../actor';
type WorkflowStartedEventHeaderProps = {
  data: UserTimelineEventWorkflowStarted['data'];
};
const WorkflowStartedEventHeader = t0 => {
  const $0 = _c(19);
  const {
    data
  } = t0;
  let t1;
  if ($0[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "auditTrail.timeline.workflowStartedEvent"
    };
    $0[0] = t1;
  } else {
    t1 = $0[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  if (data.kind === "playbook") {
    let t2;
    if ($0[1] !== data.actor || $0[2] !== data.workflowSource) {
      t2 = $ => {
        if (data.workflowSource !== "tenant") {
          return $.auditTrail.timeline.workflowStartedEvent.startedOnboardingOnto;
        }
        if (data.actor) {
          return $.auditTrail.timeline.workflowStartedEvent.actorStartedOnboardingOnto;
        }
        return $.auditTrail.timeline.workflowStartedEvent.startedRunningPlaybook;
      };
      $0[1] = data.actor;
      $0[2] = data.workflowSource;
      $0[3] = t2;
    } else {
      t2 = $0[3];
    }
    const getTransKey = t2;
    let t3;
    if ($0[4] !== data.actor) {
      t3 = data.actor && {
        actor: <Actor actor={data.actor} />
      };
      $0[4] = data.actor;
      $0[5] = t3;
    } else {
      t3 = $0[5];
    }
    let t4;
    if ($0[6] !== data.onboardingId || $0[7] !== data.playbook) {
      t4 = <OnboardingTraceLink onboardingId={data.onboardingId} playbook={data.playbook} />;
      $0[6] = data.onboardingId;
      $0[7] = data.playbook;
      $0[8] = t4;
    } else {
      t4 = $0[8];
    }
    let t5;
    if ($0[9] !== t3 || $0[10] !== t4) {
      t5 = {
        ...t3,
        playbook: t4
      };
      $0[9] = t3;
      $0[10] = t4;
      $0[11] = t5;
    } else {
      t5 = $0[11];
    }
    let t6;
    if ($0[12] !== getTransKey || $0[13] !== t5) {
      t6 = <div className="text-body-2 text-tertiary md:flex md:items-center md:gap-1"><Trans ns="entity-details" i18nKey={getTransKey} components={t5} /></div>;
      $0[12] = getTransKey;
      $0[13] = t5;
      $0[14] = t6;
    } else {
      t6 = $0[14];
    }
    return t6;
  }
  if (data.kind === "document") {
    let t2;
    if ($0[15] !== t) {
      t2 = t(_temp);
      $0[15] = t;
      $0[16] = t2;
    } else {
      t2 = $0[16];
    }
    let t3;
    if ($0[17] !== t2) {
      t3 = <p className="text-body-2 text-tertiary">{t2}</p>;
      $0[17] = t2;
      $0[18] = t3;
    } else {
      t3 = $0[18];
    }
    return t3;
  }
  return null;
};
export default WorkflowStartedEventHeader;
function _temp($_0) {
  return $_0.startedUploadingDocument;
}